<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">



          <el-form-item label="状态:" label-width='120px'>
            <!-- 下拉选择管理状态 -->
            <el-select v-model="value_status_code" placeholder="请选择管理状态" style="width: 150px; margin-right: 20px;"
              @change="statusChange" clearable>
              <el-option v-for="(item, index) in value_status_array" :label="item.alias" :value="item.val">
              </el-option>

            </el-select>
          </el-form-item>


          <el-form-item label="喜好:" label-width='120px'>
            <el-input v-model="submit_data.label" :placeholder="submit_rules.label.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>



    </div>




  </el-drawer>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.value_status_array=_this.data;
        _this.$post(
            "/consumer/getDemandDetails",{
              consumer_demand_code:_this.data
            }
          )
          .then(res => {
            _this.submit_data.consumer_demand_code= _this.data
            _this.value_status_code = res.data.status.alias;
            _this.value_status_array = res.data.status.select_array;
            _this.submit_data.label = res.data.label;

          }).catch(res => {

          })

      },
    },
    data() {
      return {


        show: false,



        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: [],


        // 表单数据
        submit_data: {
          consumer_demand_code:'',
          label: '',
          status: '',
        },


        submit_rules: {
          label: {
            placeholder: '请输入喜好',
            rules: {
              required: false,
              message: '喜好错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          status: {
            placeholder: '状态',
            rules: {
              required: false,
              message: '状态错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {
        _this.show = false;
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }
        _this.value_status_code = '';

      },
      // 提交
      onSubmit() {
        _this.$post(
            "/consumer/editDemandSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);
          }).catch(res => {

          })
      },



      statusChange(val) {

        _this.submit_data.status = val.toString();

      },

   

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>